import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { CheckoutReviewAndSubmitPageContext } from "@insite/content-library/Pages/CheckoutReviewAndSubmitPage";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import { ExpediteShippingModel } from "@TKCCP/Types/ApiModels";
import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    expShipping: ExpediteShippingModel;
}

const mapStateToProps = (state: ApplicationState) => {
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    return {
        cartId,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface CheckoutReviewAndSubmitExpediteShippingstyles {
    expediteShippingCheckboxGroup: CheckboxGroupComponentProps;
    expediteShippingCheckbox: CheckboxProps;
}

export const expediteShippingStyles: CheckoutReviewAndSubmitExpediteShippingstyles = {
    expediteShippingCheckbox: {
        typographyProps: {
            css: css`
                margin-left: 10px;
            `,
        },
    },
    expediteShippingCheckboxGroup: {},
};

const ExpediateShipping: FC<Props> = ({ expShipping, cartId }) => {
    const [isExpediteShipping, setisExpediteShipping] = useState(false);

    const [inProgress, setInProgress] = React.useState(false);
    const expediteShippinghandler: CheckboxProps["onChange"] = (_, value) => {
        setInProgress(true);
        setisExpediteShipping(value);
        const updateExpediteShipping = expShipping ? { ...expShipping } : ({} as ExpediteShippingModel);
        updateExpediteShipping.isExpediteShipping = value;

        localStorage.removeItem("ExpediteShipping");
        localStorage.setItem("ExpediteShipping", JSON.stringify(updateExpediteShipping));
    };
    return (
        <>
            <CheckboxGroup {...expediteShippingStyles.expediteShippingCheckboxGroup}>
                <Checkbox
                    {...expediteShippingStyles.expediteShippingCheckbox}
                    onChange={expediteShippinghandler}
                    checked={isExpediteShipping}
                    data-test-selector="expediteshipping"
                >
                    {translate("Expedite Shipping")}
                </Checkbox>
            </CheckboxGroup>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ExpediateShipping),

    definition: {
        group: "Checkout - Review & Submit",
    },
};

export default widgetModule;
